import { createFileRoute } from "@tanstack/react-router";

import { CouponsPage } from "../../../features/storefront/coupons-page";

export const Route = createFileRoute("/_app/marketing/coupons")({ component: CouponsPage });
